import type { JSX } from 'react';
import { Button } from '@/components/ui/button';
import type { InspectionVerification } from '../types/inspection.types';

interface InspectionActionsProps {
  verification: InspectionVerification;
  isProcessing: boolean;
  onApprove: (verificationId: string) => void;
  onReturn: (verification: InspectionVerification) => void;
}

/** The decision a super admin can still make on a verification awaiting inspection. */
export function InspectionActions({
  verification,
  isProcessing,
  onApprove,
  onReturn,
}: InspectionActionsProps): JSX.Element {
  return (
    <div className="flex shrink-0 gap-2">
      <Button size="sm" disabled={isProcessing} onClick={() => onApprove(verification.id)}>
        Approve
      </Button>
      <Button
        size="sm"
        variant="outline"
        disabled={isProcessing}
        onClick={() => onReturn(verification)}
      >
        Return
      </Button>
    </div>
  );
}
